/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    hasPermission: (route: {
      path: string;
      pathAlias?: string;
      routes?: { path: string; pathAlias?: string }[];
    }) =>
      currentUser &&
      (currentUser.permissions.includes(route.pathAlias || route.path) ||
        route.routes?.some((r) => currentUser.permissions.includes(r.pathAlias || r.path))),
  };
}
